import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import { pageView } from '../../scripts/analytics';
import PageLayout from '../../layouts/PageLayout';
import Header from './blocks/Header';
import Matches from './blocks/Matches';

import topVisual from '../../assets/images/espn1-top.webp';
import matchesVisual from '../../assets/images/espn1-matches1.webp';
import Providers from './blocks/Providers';

import kpnLogo from '../../assets/icons/KPN.svg';
import ziggoLogo from '../../assets/icons/Ziggo.svg';
import odidoLogo from '../../assets/icons/odido.png';
import caiwayLogo from '../../assets/icons/Caiway.svg';
import deltaLogo from '../../assets/icons/DELTA.svg';
import canaldigitalLogo from '../../assets/icons/Canaldigital.svg';
import canalPlusLogo from '../../assets/icons/canalPlus.svg';
import onlineLogo from '../../assets/icons/Online.svg';
import breedbandLogo from '../../assets/icons/Breedband.svg';
import budgetLogo from '../../assets/icons/Budget.svg';
import kabelnoordLogo from '../../assets/icons/Kabelnoord.svg';
import kabeltexLogo from '../../assets/icons/Kabeltex.svg';
import plinqLogo from '../../assets/icons/Plinq.svg';
import skpLogo from '../../assets/icons/SKP.svg';
import skvLogo from '../../assets/icons/SKV.svg';
import stipteLogo from '../../assets/icons/Stipte.svg';
import solconLogo from '../../assets/icons/Solcon.svg';
import trinedLogo from '../../assets/icons/Trined.svg';
import xs4allLogo from '../../assets/icons/XS4ALL.svg';
import youfoneLogo from '../../assets/icons/Youfone.svg';
import fiberLogo from '../../assets/icons/Fiber.svg';

const EspnOne = () => {
    let providers = [
        {
            logo: kpnLogo,
            name: 'KPN',
            title: 'Kanaal 14',
        },
        {
            logo: ziggoLogo,
            name: 'Ziggo',
            title: 'Kanaal 18',
            text: 'Minimaal tv start of standard abonnement',
        },
        {
            logo: odidoLogo,
            name: 'Odido',
            title: 'Kanaal 150',
        },
        {
            logo: caiwayLogo,
            name: 'Caiway',
            title: 'Kanaal 318',
            text: 'Standaard in tv-pakket t/m 19 februari 2023',
        },
        {
            logo: deltaLogo,
            name: 'Delta',
            title: 'Kanaal 421',
            text: 'Standaard in tv-pakket t/m 19 februari 2023',
        },
        {
            logo: canaldigitalLogo,
            name: 'Canaal Digitaal',
            title: 'Kanaal 29',
        },

        {
            logo: canalPlusLogo,
            name: 'CANAL+',
            title: 'Kanaal 29',
        },

        {
            logo: onlineLogo,
            name: 'Online',
            title: 'Kanaal 401',
        },
        {
            logo: breedbandLogo,
            name: 'Breedband Helmon',
            title: 'Kanaal 14',
        },
        {
            logo: budgetLogo,
            name: 'Budget',
            title: 'Kanaal 14',
        },
        {
            logo: kabelnoordLogo,
            name: 'Kabelnoord',
            title: 'Kanaal 310',
        },
        {
            logo: kabeltexLogo,
            name: 'Kabeltex',
            title: 'Kanaal 26',
        },
        {
            logo: plinqLogo,
            name: 'Plinq',
            title: 'Kanaal 421',
        },
        {
            logo: skpLogo,
            name: 'SKP',
            title: 'Kanaal 269',
        },
        {
            logo: skvLogo,
            name: 'SKV',
            title: 'Kanaal 541',
            text: 'Minimaal tv + internet abonnement',
        },
        {
            logo: solconLogo,
            name: 'Solcon',
            title: 'Kanaal 14',
        },
        {
            logo: stipteLogo,
            name: 'Stipte',
            title: 'Kanaal 651',
        },
        {
            logo: trinedLogo,
            name: 'Trined',
            title: 'Kanaal 251',
            text: 'ESPN Compleet zit standaard in het Familiepakket. Gratis 12 maanden ESPN Compleet voor alle nieuwe klanten.',
        },
        {
            logo: xs4allLogo,
            name: 'XS4ALL',
            title: 'Kanaal 14',
        },
        {
            logo: youfoneLogo,
            name: 'Youfone',
            title: 'Kanaal 21',
        },
        {
            logo: fiberLogo,
            name: 'Fiber',
            title: 'Kanaal 405',
        },
    ];

    useEffect(() => {
        pageView('espnOne');
    }, []);

    return (
        <PageLayout>
            <Helmet>
                <title>ESPN 1 voor iedereen! Standaard in je TV pakket</title>
                <meta
                    name="description"
                    content="ESPN 1 voor iedereen! Standaard in je TV pakket"
                />
                <meta
                    property="og:title"
                    content="ESPN 1 voor iedereen! Standaard in je TV pakket"
                />
                <meta
                    property="og:description"
                    content="Kijk zonder aanvullende abonnement naar ESPN 1. Het eerste kanaal van ESPN biedt een selectie van de beste ESPN programma's en competities."
                />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={topVisual} />
            </Helmet>
            <Header
                image={topVisual}
                title={
                    <>
                        ESPN 1 voor iedereen!
                        <br />
                        Standaard in je TV pakket
                    </>
                }
                buttons={[
                    {
                        label: 'Bekijk wedstrijdoverzicht',
                        link: '#matches',
                        track: 'campagne:espn1:wedstrijdoverzicht',
                    },
                    {
                        label: 'Kanaaloverzicht',
                        link: '#providers',
                        track: 'campagne:espn1:kanaaloverzicht',
                    },
                ]}
                bottomText="* Bekijk onderaan deze pagina welke tv-aanbieders ESPN aanbieden en onder welke voorwaarden"
            />
            <Matches
                bgImage={matchesVisual}
                title={
                    <>
                        Live voor iedereen
                        <br />
                        te zien op ESPN 1
                    </>
                }
            />
            <Providers
                title={
                    <>
                        ESPN 1 standaard in het
                        <br />
                        TV-Pakket bij
                    </>
                }
                id="providers"
                tiles={providers}
            />
        </PageLayout>
    );
};

export default EspnOne;
